import * as React from "react";
import type { SVGProps } from "react";
const SvgXSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9.707 8.293a1 1 0 0 0-1.414 1.414zm4.586 7.414a1 1 0 0 0 1.414-1.414zm1.414-6a1 1 0 0 0-1.414-1.414zm-7.414 4.586a1 1 0 1 0 1.414 1.414zM5 4h14V2H5zm14 0a1 1 0 0 1 1 1h2a3 3 0 0 0-3-3zm1 1v14h2V5zm0 14a1 1 0 0 1-1 1v2a3 3 0 0 0 3-3zm-1 1H5v2h14zM5 20a1 1 0 0 1-1-1H2a3 3 0 0 0 3 3zm-1-1V5H2v14zM4 5a1 1 0 0 1 1-1V2a3 3 0 0 0-3 3zm4.293 4.707 6 6 1.414-1.414-6-6zm6-1.414-6 6 1.414 1.414 6-6z"
    />
  </svg>
);
export default SvgXSquare;
